<template>
  <div>
    <table class="table table-striped table-bordered table-hover">
      <thead>
        <tr>
          <th>Nome</th>
          <th>Email</th>
          <th>Perfil</th>
          <th>Situação</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="usuario in usuarios" :key="usuario._id">
          <td>{{ usuario.name }}</td>
          <td>{{ usuario.email }}</td>
          <td>{{ usuario.perfil }}</td>
          <td>{{ usuario.ativo ? 'Ativo' : 'Cancelado' }}</td>
          <td>
            <RouterLink
              v-tooltip="'Editar'"
              data-test-id="link-auto-1"
              :to="'/usuario/cadastro/' + usuario._id"
              role="button"
              class="btn btn-xs btn-link"
            >
              <span class="fa fa-edit" />
            </RouterLink>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'UsuarioTabela',
  props: {
    usuarios: {
      type: Array,
      required: true,
    },
  },
}
</script>
